<template>
<div>
    <div id="testWrapper">
        <div id="startStopBtn" v-on:click="setStartStop()"></div>
        <div class="testGroup d-flex justify-content-around">
            <div class="testArea">
                <div class="testName">{{ $t('DeviceTest.NetworkTest.Ping') }}</div>
                <div id="pingText" class="meterText" >{{Ping.Ping}}</div>
                <div class="unit">ms</div>
            </div>
            <div class="testArea">
                <div class="testName">{{ $t('DeviceTest.NetworkTest.Download') }}</div>
                <div id="dlText" class="meterText">{{Download.Download}}</div>
                <div class="unit">Mbps</div>
            </div>
            <div class="testArea">
                <div class="testName">{{ $t('DeviceTest.NetworkTest.Upload') }}</div>
                <div id="ulText" class="meterText">{{Upload.Upload}}</div>
                <div class="unit">Mbps</div>
            </div>
        </div>
        <!--<input type="file" id="file" ref="file" v-on:change="handleFileUpload()" />-->
    </div>
</div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import FormData from 'form-data';
import COS from 'cos-js-sdk-v5';
// import fs from 'fs';

export default {
    name: 'netTest',
    components:{},    
    // props: ['IsTelcent'], //丟哪個測速
    data () {
        return {
            runningStatus:0, //0:stop,1:running
            stObject:null,
            Ping:{
                StartTime:'',
                EndTime:'',
                TimeList:[],
                Count:0,
                Ping:0,
                TotalTime:0,
            },
            Download:{
                StartTime:'',
                EndTime:'',
                TimeList:[],
                Count:0,
                Download:0,
                TotalTime:0,
            },
            Upload:{
                StartTime:'',
                EndTime:'',
                TimeList:[],
                Count:0,
                Upload:0,
                file:'',
                TotalTime:0,
            },
            TencentSDKEnv: {
                SecretId: 'IKIDQgjYN7f2ED6qOlFcq483lFTSChwxjGYW',
                SecretKey: 'oSvBIBqLhuzsZ3JL9j5D7sUxEMZZKuHP',
                Bucket: '',
                RegionBucket: '',
                // Bucket: 'speedtest-demo-1314427132',
                // RegionBucket: 'ap-tokyo',
                // Bucket: 'speedtest-prd-1314427132',
                // RegionBucket: 'ap-hongkong',
                SdkAppId: 20001292,
                SdkKey: '5bf0b00b0afea83182a37f4f2908313f75b11f0b6672badc17689cb3450c0372'
            },
        }
    },
    mounted(){
    },
    methods:{
        setStartStop:function(){
            if(this.runningStatus == 1){
                this.I("startStopBtn").className="";
                this.runningStatus = 0;
            }else{
                //test is not running, begin
                this.I("startStopBtn").className="running";
                this.runningStatus = 1;
                this.PingTest();
            }
        },
        PingTest(){
            if(`${process.env.NODE_ENV}` == "production"){//master
                this.TencentSDKEnv.Bucket = 'speedtest-prd-1314427132';
                this.TencentSDKEnv.RegionBucket ='ap-hongkong';                
            }else{
                this.TencentSDKEnv.Bucket = 'speedtest-demo-1314427132';
                this.TencentSDKEnv.RegionBucket ='ap-tokyo';
            }

            this.Ping.Count +=1;
            this.Ping.StartTime = moment(new Date()).format("yyyy-MM-DD HH:mm:ss.SSS")

            // 配置 COS 实例
            const cos = new COS({
                SecretId: this.TencentSDKEnv.SecretId,
                SecretKey: this.TencentSDKEnv.SecretKey
            })

            cos.headBucket({
                // Bucket: `${process.env.BUCKET}`,
                // Region: `${process.env.REGIONBUCKET}`,
                Bucket: this.TencentSDKEnv.Bucket,
                Region: this.TencentSDKEnv.RegionBucket,
            }, (err, data) => {
                if (err) {
                    console.error('Ping失败',err);
                    return;
                }else{
                    this.Ping.EndTime = moment(new Date()).format("yyyy-MM-DD HH:mm:ss.SSS")
                    this.Ping.TotalTime += moment(this.Ping.EndTime).diff(moment(this.Ping.StartTime));
                    this.Ping.Ping = moment(this.Ping.EndTime).diff(moment(this.Ping.StartTime))
                    if(this.Ping.Count < 30){
                        this.PingTest();
                    }else{
                        this.Ping.Ping = this.getAverageTime(this.Ping.TotalTime,'ping')
                        this.GLOBAL.Ping = this.Ping.Ping;
                        // console.log(this.Ping.Ping);
                        this.Ping.Count = 0;
                        this.Ping.TimeList = [];
                        this.Ping.TotalTime = 0;
                        this.DownloadTest();
                    }
                }
            });

            // this.Ping.Count +=1;
            // // const api =`https://192.168.8.143:5501/SpeedTest/Ping`;
            // const api =`https://2bapi.hitutoracdm.com:5543/SpeedTest/Ping`;
            
            // this.Ping.StartTime = moment(new Date()).format("yyyy-MM-DD HH:mm:ss.SSS")
            // axios.get(api)
            //     .then((response) => {
            //         // console.log(response)
            //         if(response.status == 200){
            //             this.Ping.EndTime = moment(new Date()).format("yyyy-MM-DD HH:mm:ss.SSS")
            //             this.Ping.TimeList.push(moment(this.Ping.EndTime).diff(moment(this.Ping.StartTime)));
            //             this.Ping.Ping = moment(this.Ping.EndTime).diff(moment(this.Ping.StartTime))
            //             if(this.Ping.Count < 30){
            //                 this.PingTest();
            //             }else{
            //                 this.Ping.Ping = this.getAverageTime(this.Ping.TimeList,'ping')
            //                 this.GLOBAL.Ping = this.Ping.Ping;
            //                 // console.log(this.Ping.Ping);
            //                 this.Ping.Count = 0;
            //                 this.Ping.TimeList = []
            //                 this.DownloadTest();
            //             }
            //         }
            //     })
            //     .catch(error => {
            //         this.errorMessage = error.message;
            //         console.error("There was an error!", error);
            //     });
        },
        DownloadTest(){ 
            var keyname = ''
            this.Download.Count += 1;
            this.Download.StartTime = moment(new Date()).format("yyyy-MM-DD HH:mm:ss.SSS")
            // 配置 COS 实例
            const cos = new COS({
                SecretId: this.TencentSDKEnv.SecretId,
                SecretKey: this.TencentSDKEnv.SecretKey,
                Protocol: 'https:'
            })
            keyname = 'speedtest/5MB_File' + this.Download.Count + '.txt'

            // 下载文件
            cos.getObject({
                // Bucket: `${process.env.BUCKET}`,
                // Region: `${process.env.REGIONBUCKET}`,
                Bucket: this.TencentSDKEnv.Bucket,
                Region: this.TencentSDKEnv.RegionBucket,
                Key: keyname,
            }, (err, data) => {
                if (err) {
                    console.error('Download Failed',err);
                    return;
                }else{
                    // 下载成功，data.Body 即为文件内容
                    // console.log(data.Body);
                    this.Download.EndTime = moment(new Date()).format("yyyy-MM-DD HH:mm:ss.SSS")

                    this.Download.TotalTime += moment(this.EndTime).diff(moment(this.Download.StartTime))
                    this.Download.Download = (5*8/(moment(this.EndTime).diff(moment(this.Download.StartTime))/1000)).toFixed(2)
                    
                    if(this.Download.Count < 15){
                        this.DownloadTest();
                    }else{
                        this.Upload.file = data.Body;
                        this.Download.Download = this.getAverageTime(this.Download.TotalTime,'download')
                        this.GLOBAL.DownloadSpeed = this.Download.Download;
                        this.Download.Count = 0;
                        this.Download.TimeList = []
                        this.Download.TotalTime = 0;
                        this.UploadTest();
                    }
                }
            });

            // this.Download.Count += 1;
            // // const api =`https://192.168.8.143:5501/SpeedTest/DownloadFile`;
            // const api =`https://2bapi.hitutoracdm.com:5543/SpeedTest/DownloadFile`;
            // this.Download.StartTime = moment(new Date()).format("yyyy-MM-DD HH:mm:ss.SSS")
            // axios.get(api)
            //     .then((response) => {
            //         if(response.status == 200){
            //             // this.Download.EndTime = moment(new Date()).format("yyyy-MM-DD HH:mm:ss.SSS")
            //             // this.Download.TimeList.push(moment(this.EndTime).diff(moment(this.Download.StartTime)));
            //             // this.Download.Download = (moment(this.EndTime).diff(moment(this.Download.StartTime))/8).toFixed(2)
            //             // if(this.Download.Count < 30){
            //             //     // this.DownloadTest();
            //             // }else{
            //                 // this.Upload.file = response.data
            //                 // this.Download.Download = this.getAverageTime(this.Download.TimeList,'download')
            //                 // this.GLOBAL.DownloadSpeed = this.Download.Download;
            //                 // console.log(this.Download.Download);
            //                 // this.Download.Count = 0;
            //                 // this.Download.TimeList = []
            //                 // this.UploadTest();
            //             // }
            //         }
            //     })
            //     .catch(error => {
            //         this.errorMessage = error.message;
            //         console.error("There was an error!", error);
            //     });
        },
        UploadTest(){
            this.Upload.Count += 1;
            this.Upload.StartTime = moment(new Date()).format("yyyy-MM-DD HH:mm:ss.SSS")
            var keyName = 'temp/5MB_File_'+moment(new Date()).format("yyyyMMDDHHmmssSSS")+'.txt'

            const cos = new COS({
                SecretId: this.TencentSDKEnv.SecretId,
                SecretKey: this.TencentSDKEnv.SecretKey
            })
            
            cos.putObject({
                // Bucket: `${process.env.BUCKET}`,
                // Region: `${process.env.REGIONBUCKET}`,
                Bucket: this.TencentSDKEnv.Bucket,
                Region: this.TencentSDKEnv.RegionBucket,
                Key: keyName,
                Body: this.Upload.file,
                onProgress: function (progressData) {
                    // console.log(JSON.stringify(progressData))
                }
            }, (err, data) => {
                if (err) {
                    console.error('Upload Failed',err);
                    // console.log('上传失败', err);
                    return;
                } else {
                    // console.log('上传成功');
                    this.Upload.EndTime = moment(new Date()).format("yyyy-MM-DD HH:mm:ss.SSS")
                    this.Upload.TotalTime += moment(this.EndTime).diff(moment(this.Upload.StartTime));
                    this.Upload.Upload = (5*8/(moment(this.EndTime).diff(moment(this.Upload.StartTime))/1000)).toFixed(2)
                    
                    if(this.Upload.Count < 15){
                        this.UploadTest();
                        // console.log(this.Upload.Upload)
                    }else{
                        this.Upload.Upload = this.getAverageTime(this.Upload.TotalTime,'upload')
                        this.GLOBAL.UploadSpeed = this.Upload.Upload;
                        this.Upload.Count = 0;
                        this.Upload.TotalTime = 0;
                        this.Upload.TimeList = []
                        this.GLOBAL.NetOK = true;
                        if(this.$root.$refs.deviceTest != undefined){
                            this.$root.$refs.deviceTest.getNetOK();
                        }else{
                            this.$root.$refs.SimpleDeviceTest.getNetOK();
                        }
                        // this.$root.$refs.deviceTest.getNetOK();
                        this.setStartStop();
                    }
                }
            });            

            // // const api =`https://192.168.8.143:5501/SpeedTest/UploadFile`;
            // const api =`https://2bapi.hitutoracdm.com:5543/SpeedTest/UploadFile`;
            // const FormData = require('form-data');

            // let form = new FormData();
            // form.append('files',this.Upload.file)
            // // console.log(form);
            // this.Upload.StartTime = moment(new Date()).format("yyyy-MM-DD HH:mm:ss.SSS")
            // axios.post(api, form)
            //     .then((response) => {
            //         if(response.status == 200){
            //             this.Upload.EndTime = moment(new Date()).format("yyyy-MM-DD HH:mm:ss.SSS")
            //             this.Upload.TimeList.push(moment(this.EndTime).diff(moment(this.Upload.StartTime)));
            //             this.Upload.Upload = (moment(this.EndTime).diff(moment(this.Upload.StartTime))/8).toFixed(2)
            //             if(this.Upload.Count < 30){
            //                 this.UploadTest();
            //                 // console.log(this.Upload.Upload)
            //             }else{
            //                 this.Upload.Upload = this.getAverageTime(this.Upload.TimeList,'upload')
            //                 this.GLOBAL.UploadSpeed = this.Upload.Upload;
            //                 this.Upload.Count = 0;
            //                 this.Upload.TimeList = []
            //                 this.GLOBAL.NetOK = true;
            //                 if(this.$root.$refs.deviceTest != undefined){
            //                     this.$root.$refs.deviceTest.getNetOK();
            //                 }else{
            //                     this.$root.$refs.SimpleDeviceTest.getNetOK();
            //                 }
            //                 // this.$root.$refs.deviceTest.getNetOK();
            //                 this.setStartStop();
            //             }
            //         }
            //     })
            //     .catch(error => {
            //         this.errorMessage = error.message;
            //         console.error("There was an error!", error);
            //     });
        },
        getAverageTime(TimeTotal,type){
            var avgTime = 0
            
            switch(type){
                case 'ping':
                    avgTime = (TimeTotal /30).toFixed(2)
                break
                case 'download':
                    //(一個檔案大小(Mb)*8*次數) / 秒數加總(TimeTotal為毫秒)
                    avgTime = (5*8*15/(TimeTotal/1000)).toFixed(2)
                break
                case 'upload':
                    //(一個檔案大小(Mb)*8*次數) / 秒數加總(TimeTotal為毫秒)
                    avgTime =(5*8*15/(TimeTotal/1000)).toFixed(2)
                break
                default:
                    avgTime = 0
                break
            }
            return avgTime;
        },
        I(i){return document.getElementById(i);},

        handleFileUpload() {
            this.file = this.$refs.file.files[0];
            console.log('>>>> 1st element in files array >>>> ', this.$refs.file.files);
        } 
    }
}
</script>


// WEBPACK FOOTER //
// src/components/DeviceTestPages/netTest.vue